// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__OL6yy","password":"PasswordResetForm_password__3Ynfh"};